/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigurationTable_ConfigurationFragmentDoc } from '../../../../../../components/configurations/ConfigurationsTable/__generated__/ConfigurationsTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerConfigurationsPageQueryVariables = Types.Exact<{
  customerHandle: Types.Scalars['String'];
  pageNumber: Types.Scalars['Int'];
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  filter?: Types.InputMaybe<Types.ConfigurationFilters>;
}>;


export type CustomerConfigurationsPageQuery = { __typename: 'Query', customer?: { __typename: 'Customer', id: string, supportedPlatforms: Array<string>, customerDefaultConfigurations?: { __typename: 'DefaultConfiguration', id: string, type: Types.DefaultConfigurationType, defaultConfigurations: Array<{ __typename: 'DefaultConfigurationMap', platform: string, configurationId: string }> } | null, multiClaimDefaultConfigurations?: Array<{ __typename: 'DefaultConfiguration', id: string, type: Types.DefaultConfigurationType, defaultConfigurations: Array<{ __typename: 'DefaultConfigurationMap', platform: string, configurationId: string }> }> | null, configurations: Array<{ __typename: 'ConfigurationModel', id: string, customerId: string, platform: string, name: string, state: Types.ConfigurationStatus, description?: string | null, createdAt: any, version: number, draft?: { __typename: 'ConfigurationModel', id: string, name: string, description?: string | null, state: Types.ConfigurationStatus, platform: string } | null }> } | null };


export const CustomerConfigurationsPageDocument = gql`
    query CustomerConfigurationsPage($customerHandle: String!, $pageNumber: Int!, $searchTerm: String, $filter: ConfigurationFilters) {
  customer: customerByHandle(handle: $customerHandle) {
    id
    supportedPlatforms
    customerDefaultConfigurations {
      id
      type
      defaultConfigurations {
        platform
        configurationId
      }
    }
    multiClaimDefaultConfigurations {
      id
      type
      defaultConfigurations {
        platform
        configurationId
      }
    }
    configurations(
      pageNumber: $pageNumber
      searchTerm: $searchTerm
      filter: $filter
    ) {
      ...ConfigurationTable_configuration
    }
  }
}
    ${ConfigurationTable_ConfigurationFragmentDoc}`;

/**
 * __useCustomerConfigurationsPageQuery__
 *
 * To run a query within a React component, call `useCustomerConfigurationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerConfigurationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerConfigurationsPageQuery({
 *   variables: {
 *      customerHandle: // value for 'customerHandle'
 *      pageNumber: // value for 'pageNumber'
 *      searchTerm: // value for 'searchTerm'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerConfigurationsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomerConfigurationsPageQuery, CustomerConfigurationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerConfigurationsPageQuery, CustomerConfigurationsPageQueryVariables>(CustomerConfigurationsPageDocument, options);
      }
export function useCustomerConfigurationsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerConfigurationsPageQuery, CustomerConfigurationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerConfigurationsPageQuery, CustomerConfigurationsPageQueryVariables>(CustomerConfigurationsPageDocument, options);
        }
export type CustomerConfigurationsPageQueryHookResult = ReturnType<typeof useCustomerConfigurationsPageQuery>;
export type CustomerConfigurationsPageLazyQueryHookResult = ReturnType<typeof useCustomerConfigurationsPageLazyQuery>;
export type CustomerConfigurationsPageQueryResult = ApolloReactCommon.QueryResult<CustomerConfigurationsPageQuery, CustomerConfigurationsPageQueryVariables>;